import { getStatusDescriptionFromStatusValue } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

export default function dealListColumnSpecifications(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach(deal => {
        let row = [];
        const rowId = deal.dealId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let linkDestination = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "company") {
                    columnValue = deal.company || "";
                }
                else if (columnId === "orgId") {
                    columnValue = deal.orgId || "";
                }
                else if (columnId === "revitalizeDeal") {
                    columnValue = deal.revitalizeDeal || "";
                }
                else if (columnId === "dealType") {
                    columnValue = deal.dealType || "";
                }
                else if (columnId === "numOfRevitalizeCountry") {
                    columnValue = deal.numOfRevitalizeCountry || "";
                }
                else if (columnId === "dealExpirationDate") {
                    columnValue = getDateWithSpecificFormat(deal.dealExpirationDate);
                }
                else if(columnId === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(deal.status) || "";
                }

            }
            else if (columnDataType === "selectionCheckBox") {
                if (columnId === "completedStatus") {
                    columnValue = deal.status === 'COMPLETED' ? true : false;
                    isDisabled = deal.status === 'COMPLETED' ? true : false;
                }
            }
            else if (columnDataType === "link") {
                if (columnId === "dealId" && deal.dealId) {
                    columnValue = deal.dealId;
                    linkDestination = '/control-tower-settings/deal-detail/' + deal.dealId;
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    linkDestination: linkDestination,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, rowId) : null
                }
            });
        });

        row.push({
            ['status']: { value: deal.status }
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
